import React, { Component, Fragment } from 'react';
import ConfirmReapproExt from './ConfirmReapproExt';
import FormLayout from '../containers/FormLayout.jsx';
import Select from 'react-select'
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { isEmpty } from "lodash";
import Spin from '../../../../commonModules/interface/Spin';
import { TableRow, TableCell, Button, Box, Grid, IconButton } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import Photos from '../../../../commonModules/interface/input-files';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';

class FormReapproExt extends Component {
    state = {
        sending: false,
        match_dest_email: "",
        match_dest_account: "",
        step: 1,
        match_products: {},
        
        confirmSubmit:false,
        numberProd:1,

        // New reappro
        reappro:{
            shop: "",
            shop_dest: "",
            // shop_dest: "12171aeb-022f-441b-9eb0-b8a626bb48e0",
            shopDisplay:{},
            shop_destDisplay:{},
            natureDisplay:{value:"reapprovisionnement_ext", label:"Réapprovisionnement"},
            nature:"reapprovisionnement_ext",
            transport: "",
            taxes: "",            
            comments: "",
            discount: 0,
            total: 0,
            price_margin: 0,
            transfer_files_req: null,
            products:[
                {
                    display:{value:"", label:""},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    stock_id_dest:"",
                }
            ],
            unique_id: generateUniqueId()
        },

        //errors?
        errors:{
            shop: "",
            shop_dest: "",
            quantity: "",
            nature:"",
            transport:"",
            discount:"",
            taxes:"",
            price_margin:"",
            products:[
                {
                    product_id:"",
                    quantity:"",
                }
            ],
            match_dest_email: "",
        },
        
        sending: false,
        form: <div></div>  // Liste des produits
    }

    filterShopsList = () => {
        const { match_products } = this.state
        const  { AVAILABLE, SHOPS } = this.props
        let filteredShops = [] 
        
        Object.values(SHOPS).forEach( shop => {
            let stockMatch = []
            Object.keys(match_products).forEach( prodID => {
                stockMatch = stockMatch.concat(Object.values(AVAILABLE).filter( stock => 
                    stock.product_id === prodID && stock.shop_id === shop.id  && stock.quantity > 0
                ))
            })
            if(stockMatch.length > 0 ){
                filteredShops.push( shop )
            }
        })
        return filteredShops

    }
    createShopList = () => {
        const list = []
        const { reappro } = this.state
        const { AVAILABLE } = this.props

        if( AVAILABLE ){
            this.filterShopsList().map( shop => { 
                let selected = !!shop.shop_disabled
                if( reappro.shop === shop.id || reappro.shop_dest === shop.id  )   {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value:shop.id, label:shop.name, disabled:selected} 
                )
            })
        
        }
        return list
    }

    filterProductsList = () => {
        const { match_products } = this.state
        const  { AVAILABLE } = this.props
        let filteredProducts = [] 
        
        Object.keys(match_products).forEach( prodID => {
            let stockMatch = Object.values(AVAILABLE).filter( stock => stock.product_id === prodID)
            filteredProducts = filteredProducts.concat( stockMatch )
            // console.log("filterProducts",{filteredProducts});
        })
        // console.log('====================================');
        // // console.log({filteredProducts});
        // console.table(filteredProducts)
        // console.log('====================================');
        return filteredProducts
    }
   

    createProductList = () => {
        const { reappro, match_products } = this.state
        const  { AVAILABLE, PRODUCTS } = this.props
        const list = [{value:"", label:"Chosissez un Produit"}]
        if(!isEmpty(AVAILABLE) && !isEmpty(match_products) ){

            this.filterProductsList().map( item => {   
                let selected = false
                reappro.products.map( prod => {   
                    if(prod.product_id  === item.product_id)   {  // already selected   
                        selected = true 
                    } 
                })
                if(item.shop_id === reappro.shop && item.quantity > 0){
                    list.push ({
                        value: item.product_id, 
                        label:`${PRODUCTS[ item.product_id ].marque} - ${PRODUCTS[ item.product_id ].name} — ${PRODUCTS[ item.product_id ].ref}`, 
                        disabled:selected
                    })
                }
            })
        }
        return list
    }

    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});
        let value = option.value
        let displayName = name +'Display'

        if(name === "nature"){
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            })
            
        } else if(name === "shop"){
            console.log("change shop");
            
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                            stock_id:"",
                            stock_id_dest:"",
                            
                        }
                    ],
                },
                numberProd:1
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        } else {

            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    [name]:value,
                    [displayName]:option
                }
            })
        }
    }
    
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const shop = this.state.reappro.shop
        const max = this.findMax(value, shop)    

        let cpProducts = this.state.reappro.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max[0]
        cpProducts[index].stock_id = max[1]
        cpProducts[index].reduc_max = max[3]
        cpProducts[index].match_src_product = value
        cpProducts[index].match_dest_product = this.state.match_products[value].match_dest_product
        cpProducts[index].display = option
        
        console.table(cpProducts)
        
        const maxDest = this.findMax(value, this.state.reappro.shop_dest, this.props.WAITING)
        console.log("REA, max shop_dest res", maxDest)

        cpProducts[index].stock_id_dest = maxDest[1]
        
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                products:cpProducts,
            }
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }

// FORMS MANAGER
    findMax = (product_id, shop_id, list = this.props.AVAILABLE) => { // return available stock and it's id
        const { PRODUCTS } = this.props    
        let max = 0
        let stock_id = ""
        let reducMax = 0
         Object.values(list).map( stock => {            
            if(stock.product_id === product_id  && stock.shop_id === shop_id ){
                console.log("[DEBUG],findMax, found match, ",product_id," and shopid",shop_id)
                max = stock.quantity
                stock_id = stock.id
                reducMax = PRODUCTS[stock.product_id].reduc_max
                return                    
            }
        })   
        // console.log("findMax", max,);
        return [max, stock_id, reducMax]
    }

    createAddForm = () => {
        const tab = []
        const products = this.createProductList()

        for (let i = 0; i < this.state.numberProd; i++) {
            tab.push(
                <TableRow key={i}>  
                    {/* <TableCell>
                        {this.state.numberProd > 1 &&
                        <IconButton type="button" className="delete-line" onClick={()=> this.handleDeleteProd(i)}
                        >
                            <CloseRounded color="error" />
                        </IconButton>
                        }
                        <InputSelectMagasin
                            options={products}
                            value={this.state.reappro.products[i].display }
                            label="Produit"
                            placeholder="Selectionner un Produit"
                            onChange={ option => this.handleSelectProducts(option,i)}
                            error={this.state.errors.products[i].product_id}
                        />    
                    </TableCell>                       */}
                    
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.reappro.products[i].display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        PRODUCTS={this.props.PRODUCTS}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={this.state.reappro.products[i].max} 
                            step={10} 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={this.state.reappro.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            placeholder="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={this.state.reappro.products[i].max ? "Disponible : "+ this.state.reappro.products[i].max :"" }
                        />
                    </TableCell>
                </TableRow>                  
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the sale
        const shop_id = this.state.reappro.shop
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                products:[
                    ...this.state.reappro.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    stock_id_dest:"",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",
                    
                    
                }]
            },
            numberProd:this.state.numberProd+1,
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Reappro Ext  ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.reappro.shop
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Reappro Ext ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            const max = this.findMax(value[5].id, shop_id) 
            const maxProductNumber =  max[0]
            const stock_id = max[1]
            //Check Stock ID  
            if (stock_id ==="" || typeof stock_id === "undefined"){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            //Check stock maximal
            if (maxProductNumber<value[2]) {
                toast.error( "Produit '"+ value[5].name+ "' pas de quantite suffisante dans le magasin")
                return
            }
            console.log("Form Reappro Ext ,handleAddProdByCSV, MAX value",maxProductNumber,"vs",value[2]," for ",value[5].name)

            const maxDest = this.findMax(value, this.state.reappro.shop_dest, this.props.WAITING)
            nbOfProduct++
             const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: maxProductNumber,
                stock_id: stock_id,
                stock_id_dest: maxDest[1],
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
        })
        console.log("Form Reappro Ext ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Reappro Ext,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    products:[...productListLocal]
                },
                errors:{
                    ...this.state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.reappro.products)
        let cpErrors = [].concat(this.state.errors.products)
        let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        cpProducts.map( prod => {
            if ( prod.priceR && prod.quantity && prod.priceTotal){
                total += parseFloat(prod.priceTotal)
            }
        }) 
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                products: cpProducts,
                total
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
            
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }
    handleChange =  (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"
            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(this.state.reappro.products)
            cpProducts[index][name] = value
            if(name === "quantity" || name === "price" || name === "priceTotal") {   
                if(value ==="" || regex.test(value)){// update value only if its a int
                let discount = 0;
                             
                    this.setState({
                        ...this.state,
                        reappro:{
                            ...this.state.reappro,
                            products:cpProducts,
                            discount,
                        }
                    }, () =>{
                        // Organise la visualisation des produits
                        this.createAddForm()
                    }) 
                }
            } else {
                this.setState({
                    ...this.state,
                    reappro:{
                        ...this.state.reappro,
                        products:cpProducts,
                    }
                }, () =>{
                    // Organise la visualisation des produits
                    this.createAddForm()
                }) 
            }
        } else {
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    [field]:value
                }
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        }        
    }
    setFiles = (list) => {
        console.log("[INFO] SETFILES", list);
        
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                transfer_files_req:list
            }
        })
    }
    validate = async () => {
        const { reappro } = this.state
        let noErrors = true
        let errors = this.state.errors
        const notRequired = ["comments"]
        // const validDiscount = await this.validateReduc()

        Object.keys(reappro).map(field => {
            console.log(field);
            
            if(
                (reappro[field] === "" && !notRequired.includes(field)) || 
                reappro[field] === [] ){// input is empty  
                    noErrors = false
                    errors[field]="Veuillez remplir ce champ"
                    
            } else if(field === "products"){
                reappro.products.map( (item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(field2 === "max" || field2 === "stock_id_dest" ){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0" ){
                            noErrors = false
                            errors.products[j][field2] ="Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }

                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })

        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
        if(noErrors){
            this.setState({
                confirmSubmit: true
                
            })
        } else {// !VALIDATE
            toast.error(  "Le formulaire contient des erreurs")
        }
    }
    
    handleSubmit = async () => {
        this.setState({
            sending: true
        })
        const reappro = Object.assign({}, this.state.reappro);
        reappro.id = ""
        reappro.shop_id = reappro.shop
        reappro.date = new Date()
        reappro.return_id = []
        reappro.transport = parseFloat(reappro.transport)                      
        reappro.taxes = parseFloat(reappro.taxes) 
        reappro.price_margin = parseFloat(reappro.price_margin) 
        reappro.discount = parseFloat(reappro.discount) 
        for (let i = 0; i < reappro.products.length; i++){
            reappro.products[i].quantity = parseInt(reappro.products[i].quantity)
        }
            
        try{
            const responseRequest = await this.props.createReapproExt(reappro)
            console.log(responseRequest)
            console.log("fetched");
            //success 
            this.setState({
                sending: false,
            })
            toast.info("Opération enregistrée avec succès")
            this.props.handleClose()
        }catch(err){
            console.log("ERROR,createReapproExt,response,", err );

            this.setState({
                sending: false,
            })
            toast.error("FAILED"+ err.message)
        } 
    }
    validateStep1 = async () => {
        await this.findUserAccountID()
        if(this.state.match_dest_account){
            // check if account has default shop
            await this.findUserDefaultShop()
            if(this.state.reappro.shop_dest){
                await this.getMatchList()
                this.changeStep(2)
            } 
        }
    }
    changeStep = (step) => {
        this.setState({
            step,
        })
    }

    getMatchList = async () => {
        try {
            let req = await fetch('/stocks/match/list',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({data: this.state.match_dest_account}),
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log('====================================');
            console.log("findProductInfo", {res});
            console.log('====================================');
            
            if(!res.error){

                let match_products = {} 
                if(res) {
                    res.forEach( match => {
                        match_products[match.match_src_product] = match
                    } )
                }

                this.setState({
                    match_products,
                })

            } else {
                console.log('====================================');
                console.log(res.error);
                console.log('====================================');
            }
        } catch (error) {
            console.log('====================================');
            console.log(error);
            console.log('====================================');
        }
    }

    handleChangeEmail = (e) => {
        const { name, value} = e.target;
        this.setState({ [name]: value })
    }
    
    findUserAccountID = async () => {
        const { match_dest_email } = this.state;
        if( !isEmpty(match_dest_email)){

            /***** STEP 1 ******/
                // send email to global DB
                // check if email correspond to existing user and return Stock Account ID
            try {
                let req = await fetch('/stocks/match/find/account',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify({email: match_dest_email}),
                    credentials: 'same-origin',
                })
                const res = await req.json()
                console.log('====================================');
                console.log("findUserAccountID", {res});
                
                if(!res.error && !isEmpty(res.accountID) ){

                    this.setState({
                        match_dest_account: res.accountID,
                        errors: {
                            ...this.state.errors,
                            match_dest_email: ""
                        }
                    })
    
                } else {
                    toast.error(  "Pas de compte correspondant à cet email")
                }
            } catch (error) {
                console.log("catch findUserAccountID", error);
                
                toast.error(  "Un Problème est survenu")
            }
        } else {
            this.setState({
                ...this.state,
                errors: {
                    ...this.state.errors,
                    match_dest_email: "Veuillez remplir ce champ"
                }
            })
        }
    }

    findUserDefaultShop = async () => {
        const { match_dest_account } = this.state;
        if( !isEmpty(match_dest_account)){

            try {
                let req = await fetch('/stocks/reappro/ext/user/default/shop',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify({data: match_dest_account}),
                    credentials: 'same-origin',
                })
                const res = await req.json()
                console.log('====================================');
                console.log("findUserDefaultShop", {res});
                
                if(!res.error && !isEmpty(res.id) ){

                    this.setState({
                        reappro:{
                            ...this.state.reappro,
                            shop_dest: res.id
                        }
                    })
    
                } else {
                    toast.warning( "Ce compte n'a pas renseigné de magasin de reception, impossible de continuer")
                }
            } catch (error) {
                console.log("catch findUserDefaultShop", error);
                
                toast.error(  "Un Problème est survenu")
            }
        } else {
            this.setState({
                ...this.state,
                errors: {
                    ...this.state.errors,
                    match_dest_email: "Veuillez remplir ce champ"
                }
            })
        }
        
    }
    render() {
        console.log('=============STATE=======================');
        console.log(this.state);
        console.log('====================================');
        const shops = this.createShopList()
        return (
            <div className="card-text">
                {this.props.STATE.sales.fetching && <Spin /> }
                {this.state.confirmSubmit &&
                    <ConfirmReapproExt 
                        handleClose={ () => this.setState({ confirmSubmit: false })}
                        handleSubmit={ this.handleSubmit }
                        reappro={this.state.reappro}
                        fetching={this.props.STATE.sales.fetching}
                    />
                }
              
                <Box p={3}>
                    {this.state.step === 1 &&
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <InputText 
                                    width="col-xs-12"
                                    widthLabel="col-xs-12"
                                    name="match_dest_email"
                                    value={this.state.match_dest_email}
                                    error={this.state.errors.match_dest_email}
                                    errorClass={!!this.state.errors.match_dest_email}
                                    change={this.handleChangeEmail}
                                    title="Compte Destinataire"
                                    placeholder="Entrez l'email du compte destinataire"
                                    inpuSize="input-lg"
                                />                    
                            </Grid>
                            
                            <Grid item xs={12}>
                                <Button color="secondary" variant="contained" onClick={ this.validateStep1 }>Valider</Button>
                                <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                            </Grid>
                        </Grid> 
                    }
                        
                    {this.state.step === 2 && this.state.match_dest_account && 
                        <Fragment>
                            <h4>Envoi de produits vers {this.state.match_dest_email}</h4>
                            <InputSelect
                                options={shops}
                                value={this.state.reappro.shop}
                                onChange={ option => this.handleSelect(option,"shop")}
                                // isOptionDisabled={ option => option.disabled === true}
                                error={this.state.errors.shop}
                                label="Shop Source"
                            /> 
                            
                            <InputText 
                                type="number" 
                                id="transport" 
                                className="form-control input-sm" 
                                onChange={this.handleChange} 
                                value={this.state.reappro.transport} 
                                name="transport" 
                                title="Coût Transport" 
                                error={this.state.errors.transport}
                            />
                                
                            <InputText 
                                type="number" 
                                id="taxes" 
                                className="form-control input-sm" 
                                onChange={this.handleChange} 
                                value={this.state.reappro.taxes} 
                                name="taxes" 
                                title="Autres Taxes"
                                error={this.state.errors.taxes}
                            />
                            {/* <div className={"form-group "+ (this.state.errors.taxes ? "has-error" : "") }>
                                <label htmlFor="taxes" className="col-sm-3 control-label">Autres Taxes</label>
                                <div className="col-sm-9">
                                    <div className={"fg-line "}>
                                        <small className="help-block"></small>
                                    </div>
                                </div>
                            </div> */}
                            
                            <InputText 
                                type="number" 
                                id="price_margin" 
                                className="form-control input-sm" 
                                onChange={this.handleChange} 
                                value={this.state.reappro.price_margin} 
                                name="price_margin" 
                                error={this.state.errors.price_margin}
                                title="Marge (%)"
                            />
                            {/* <div className={"form-group "+ (this.state.errors.price_margin ? "has-error" : "") }>
                                <label htmlFor="price_margin" className="col-sm-3 control-label">Marge (%)</label>
                                <div className="col-sm-9">
                                    <div className={"fg-line "}>
                                        <small className="help-block"></small>
                                    </div>
                                </div>
                            </div> */}
                            <InputText 
                                type="text" 
                                id="comments"
                                value={this.state.reappro.comments} 
                                name="comments" 
                                onChange={this.handleChange}
                                title="Remarques"
                                multi
                                rows={2}
                            />
                            <Box p={1}>
                                <label htmlFor="transfer_files_req" className="control-label">Documents</label>
                                <Photos
                                    photoList={this.setFiles} 
                                    photos={this.state.reappro.transfer_files_req === null ? [] : this.state.reappro.transfer_files_req } 
                                    file 
                                />
                            </Box>
                            <Box>
                                {/* <FormLayout title={"Produits"} rea>
                                    {this.createAddForm()}
                                    <TableRow className="plus-btn" onClick={this.handleAddProd}>
                                        <TableCell colSpan={2}>
                                            <a> 
                                                <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"></i>
                                                <span>Ajouter un produit</span> 
                                            </a>
                                        </TableCell>
                                    
                                    </TableRow>
                                </FormLayout> */}
                                <FormLayout 
                                    {...this.props} 
                                    title={"Produits"}
                                    rea
                                    createAddForm={this.state.form}
                                    onClick={this.handleAddProd}
                                    onClickForCSVUpload={this.handleAddProdByCSV}
                                    colSpan={2}
                                /> 
                            </Box>
                            <Box p={2}>
                                <div className="pull-right">
                                    <Button 
                                        color="secondary"
                                        variant="contained"
                                        onClick={this.validate}
                                        disabled={this.props.STATE.sales.fetching}
                                    >
                                        Valider
                                    </Button>
                                    <Button 
                                        color="secondary" 
                                        onClick={() => this.changeStep(1)}
                                    >
                                        Annuler
                                    </Button>
                                    
                                </div>
                            </Box>
                        </Fragment>
                        }                        
                </Box>
            </div>
        );
    }
}

export default FormReapproExt;